module.exports = __webpack_public_path__ + "img/ios-cash.2d670abc.svg";